function capitalizeFirstCharOfSegments(string, delimiter = " ") {
  return string
    .split(delimiter)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(delimiter);
}

export default capitalizeFirstCharOfSegments;
